module.exports = __webpack_public_path__ + "7c231b085c236da59b5b6f9169052869.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/frust_unclear.svg
// module id = 37
// module chunks = 0